import React from "react";

// Dependencies
import ProdigioTheme from "prodigio-themes";

// Assets
import logo from "static/promilitares/logo.svg";
import logoSmall from "static/promilitares/logoSmall.svg";
import logoWhite from "static/promilitares/logoWhite.svg";

// Social Icons
import FacebookIcon from "prodigio-icons/web/outlined/Facebook";
import IntsgramIcon from "prodigio-icons/web/outlined/Instagram";
import TwitterIcon from "prodigio-icons/web/outlined/Twitter";
import YoutubeIcon from "prodigio-icons/web/outlined/Youtube";

// Navigation Icons
import ProjectIcon from "prodigio-icons/web/outlined/Project";
import ProvasAnterioresIcon from "prodigio-icons/web/outlined/ProvasAnteriores";
import StudyPlanIcon from "prodigio-icons/web/outlined/StudyPlan";
import SubjectIcon from "prodigio-icons/web/outlined/Subject";
import FileIcon from "prodigio-icons/web/outlined/Apoio";
import QRCode from "prodigio-icons/web/outlined/QrCode";
import SimuladoIcon from "prodigio-icons/web/outlined/Simulado";
import EssayIcon from "prodigio-icons/web/outlined/Essay";
import CalendarIcon from "prodigio-icons/web/outlined/Calendar";
import CustomExerciseListIcon from "prodigio-icons/web/outlined/CustomExerciseList";

// Apps Icons
import AppStoreIcon from "prodigio-icons/web/outlined/AppStore";
import GooglePlayIcon from "prodigio-icons/web/outlined/GooglePlay";

// Helpers
import { INavigation } from "interfaces/INavigation";
import { generateThemeData } from "helpers/generate-theme-data";

const prodigioTheme = new ProdigioTheme({
    project: {
        appUrl: "app.promilitares.com.br",
        brand: "promilitares",
        logo,
        logoWhite,
        logoSmall,
        name: "Promilitares",
        slug: "promilitares",
        url: "app.promilitares.com.br"
    },
    mainColors: {
        base: "#83899E",
        brand: "#298716",
        secondary: "#AD641F"
    }
});

export const theme = generateThemeData(prodigioTheme, {
    brand: {
        100: "#87D841",
        200: "#56AF08",
        300: "#298716",
        400: "#156D00",
        500: "#135204"
    },
    secondary: {
        100: "#FACD53",
        200: "#FFBA00",
        300: "#AD641F",
        400: "#94551B",
        500: "#6A3B0F"
    }
});

export const menuColors: any = {};

export const navigation: INavigation[] = [
    {
        name: "Plano de estudos",
        url: "/app/meu-plano-de-estudos",
        icon: <StudyPlanIcon width="22" height="22" />
    },
    {
        name: "Módulos",
        url: "/app/materias",
        icon: <SubjectIcon width="22" height="22" />
    },
    {
        name: "Redações",
        url: "/app/redacoes",
        icon: <EssayIcon width="22" height="22" />
    },
    {
        name: "Simulados",
        url: "/app/simulados",
        icon: <SimuladoIcon width="22" height="22" />
    },
    {
        name: "Banco de questões",
        url: "/app/banco-de-questoes",
        icon: <CustomExerciseListIcon width="22" height="22" />
    },
    {
        name: "Projetos",
        url: "/app/projetos",
        icon: <ProjectIcon width="22" height="22" />
    },
    {
        name: "Provas anteriores",
        url: "/app/provas-anteriores",
        icon: <ProvasAnterioresIcon width="22" height="22" />
    },
    {
        name: "Agenda de aulas",
        url: "/app/plano-de-estudos",
        icon: <CalendarIcon width="22" height="22" />
    },
    {
        name: "Comunicados",
        url: "/app/arquivos",
        icon: <FileIcon width="22" height="22" />
    },
    {
        name: "QRCode",
        url: "/app/qr-code",
        icon: <QRCode width="22" height="22" />
    }
];

export const socialNetworks = [
    {
        name: "Facebook",
        url: "https://www.facebook.com/promilitares",
        icon: <FacebookIcon width="16" height="16" />
    },
    {
        name: "Twitter",
        url: "https://twitter.com/promilitares",
        icon: <TwitterIcon width="16" height="19" />
    },
    {
        name: "Instagram",
        url: "https://www.instagram.com/promilitares",
        icon: <IntsgramIcon width="16" height="16" />
    },
    {
        name: "Youtube",
        url: "https://www.youtube.com/user/ProMilitares",
        icon: <YoutubeIcon width="23" height="16" />
    }
];

export const mobileApps = [
    {
        name: "Google Play",
        url: "/app/",
        icon: <GooglePlayIcon height="16" width="15" />
    },
    {
        name: "App Store",
        url: "/app/",
        icon: <AppStoreIcon height="16" width="16" />
    }
];
